<div *ngIf="currentCard$ | async as currentCard">    
    <div class="bs-row labels">
        <span class="bs-col-md-9 bs-col-xl-10"><b>{{currentCard.dimensionName}}:</b></span>
        <span class="bs-col-md-3 bs-col-xl-2"><b>{{currentCard.metricOneName}}:</b></span>        
        <span *ngIf="!!currentCard.metricTwoName" class="bs-col-md-3 bs-col-xl-2">
            <b>{{currentCard.metricTwoName}}:</b>
        </span>
        <mat-divider></mat-divider>
    </div>
    <div class="bs-row" *ngFor="let cc of currentCard.barValues">
        <div class="bs-col-12">{{cc.dimensionValueName}}</div>
        <div class="bs-col-md-9 bs-col-xl-10">
            <div class="bs-border">
                <table [ngStyle]="{ 'width': cc.barWidth }"
                        [matTooltip]="cc.tooltipText"
                        [matTooltipPosition]="'above'"
                >
                <tr>
                    <td [ngStyle]="cc.barStyleOne"></td>
                    <td [ngStyle]="cc.barStyleTwo"></td>
                </tr>
                </table>
            </div>
        </div>
        <div class="bs-col-md-3 bs-col-xl-2">
        {{cc.metricOneDisplay}}
        </div>
    </div>
</div>

    